import { TypographyColor } from 'melp-design/components';
import { SupplierStatus } from './suppliers.types';

export const COLOR_BY_STATUS: Record<SupplierStatus, TypographyColor> = {
  active: 'success',
  inactive: 'textSecondary',
};
